import { parcelStatusEnumList } from "@/model/enum/parcel-status-enum"
import { Expose, Type } from "class-transformer"
import { FieldDescriptor, FieldTypeEnum } from "../field-descriptor"
import { Parcel } from "../parcel/parcel"
import ActivityHistoryLog from "./activity-history-log"

class PacelExportLog extends ActivityHistoryLog {

  @Expose()
  @Type(() => Parcel)
  public parcel: Parcel | null = null

  @FieldDescriptor({
    fieldType: FieldTypeEnum.DATE,
    fieldPrettyName: "entity.parcel.parcel_date",
    columnWidth: "80",
    hasTime: true
  })
  public get parcelDate() {
    return this.parcel.parcelDate
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.parcel_number",
    columnWidth: "120"
  })
  public get number() {
    return this.parcel._number
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.reference",
    columnWidth: "85"
  })
  public get parcelReference() {
    return this.parcel.parcelReference
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.reference2",
    columnWidth: "85"
  })
  public get parcelReference2() {
    return this.parcel.parcelReference2
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.recipient"
  })
  public get recipient() {
    return this.parcel.recipient
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.address",
    columnWidth: "90"
  })
  public get address() {
    return this.parcel.address
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.weight",
    columnWidth: "85"
  })
  public get weightKg() {
    return this.parcel.weightKg
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.pcs",
    columnWidth: "45"
  })
  public get listRankOf() {
    return this.parcel.listRankOf
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.type",
    columnWidth: "55"
  })
  public get type() {
    return this.parcel.type
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.postal_code",
    columnWidth: "100"
  })
  public get postalCode() {
    return this.parcel.postalCode
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.other",
    columnWidth: "80"
  })
  public get listOther() {
    return this.parcel.listOther
  }

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.parcel.parcel_status",
    columnWidth: "160"
  })
  public get status() {
    let status = null
    status = parcelStatusEnumList.find((entry) => {
      return entry.value === this.parcel.statusId
    })

    if (status) {
      status = status.name
    }

    return status

  }

  public static exportUrl: string | null = "parcelExportLog/export/csv"

}

export default PacelExportLog
